import { ReactNode, useMemo } from 'react';
import { FeatureFlag } from 'types/features';
import { useHasPermissions } from 'utils/permissionUtil';
import { useFeatureFlags } from 'utils/useFeatureFlags';

interface Props {
    permissions?: string[];
    hasAuthority?: boolean;
    requiredFeature?: FeatureFlag;
    children: ReactNode;
}

const PermissionGuard = ({
    permissions,
    hasAuthority = false,
    requiredFeature,
    children,
}: Props): JSX.Element | null => {
    const hasPermissions = useHasPermissions(permissions ?? []);
    const { isFlowDisabled } = useFeatureFlags(requiredFeature);

    const shouldRender = useMemo(() => {
        const hasPermission = permissions ? hasPermissions : false;
        return (hasPermission || hasAuthority) && !isFlowDisabled;
    }, [hasAuthority, hasPermissions, isFlowDisabled, permissions]);

    if (!shouldRender) return null;

    return <>{children}</>;
};

export default PermissionGuard;
